<template>
  <router-view />
</template>

<style lang="scss">
  @import '@/assets/scss/all.scss';
</style>
